export default `<div class=""><p class="successTitle">Račun za igru je uspješno registriran. <br>Dopunite svoj račun i ostvarite bonuse!<br></p>
<style>.successTitle { text-align: center;  color: #140474; font-weight: bold; text-transform: none; margin-bottom: 30px; font-size: 20px;}</style></div>`;
